import React, { useState } from 'react';
import { Eye, EyeOff, Lock, ChevronRight } from 'lucide-react';

/* ── Toggle ── */
export const Toggle = ({ checked, onChange }) => (
  <button
    className={`settings-toggle ${checked ? 'settings-toggle--on' : ''}`}
    onClick={() => onChange(!checked)}
    role="switch"
    aria-checked={checked}
  >
    <span className="settings-toggle-thumb" />
  </button>
);

/* ── Password Input ── */
export const PasswordInput = ({ value, onChange, placeholder }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="sp-input-wrap">
      <Lock size={16} className="sp-input-icon" />
      <input
        className="sp-input"
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      <button className="sp-eye-btn" type="button" onClick={() => setShow(p => !p)} tabIndex={-1}>
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
};

/* ── Section & Row helpers ── */
export const Section = ({ title, children }) => (
  <div className="settings-section">
    <p className="settings-section-title">{title}</p>
    <div className="settings-group">{children}</div>
  </div>
);

export const ToggleRow = ({ icon, iconColor, iconBg, title, subtitle, checked, onToggle }) => (
  <div className="settings-row">
    <div className="settings-row-icon" style={{ background: iconBg, color: iconColor }}>{icon}</div>
    <div className="settings-row-text">
      <span className="settings-row-title">{title}</span>
      {subtitle && <span className="settings-row-subtitle">{subtitle}</span>}
    </div>
    <Toggle checked={checked} onChange={onToggle} />
  </div>
);

export const LinkRow = ({ icon, iconColor, iconBg, title, subtitle, onClick, danger, active }) => (
  <button
    className={`settings-row settings-row--btn ${danger ? 'settings-row--danger' : ''} ${active ? 'settings-row--active' : ''}`}
    onClick={onClick}
  >
    <div className="settings-row-icon" style={{ background: iconBg, color: iconColor }}>{icon}</div>
    <div className="settings-row-text">
      <span className="settings-row-title">{title}</span>
      {subtitle && <span className="settings-row-subtitle">{subtitle}</span>}
    </div>
    <ChevronRight size={18} className={`settings-row-chevron ${active ? 'settings-row-chevron--open' : ''}`} />
  </button>
);